import React, { Fragment } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";

function RemoveCertificateFromUser(props) {
  const { index, user, removeCertificateFromUser } = props;

  return ( <Fragment>
      <Link
        to="#"
        className="cursor-pointer px-2 mx-2 link-icon-color"
        id={`remove-user-` + index}
        onClick={e => {
          e.preventDefault();
          removeCertificateFromUser( user );
        }}
      >
        <FontAwesomeIcon
          size="lg"
          className="align-middle cursor-pointer"
          pointerEvents="none"
          icon={faMinusCircle}
        />
      </Link>
      <UncontrolledTooltip
        delay={0}
        target={`remove-user-${props.index}`}
        modifiers={
          {
            preventOverflow: {
              enabled: true,
              boundariesElement: 'body'
            }
          }
        }
      >
        <FormattedMessage
          id="components.pages.admin.tabs.users_in_group_table.actionButtons.remove_user"/>
      </UncontrolledTooltip>
    </Fragment>
  );
}

export { RemoveCertificateFromUser };
